





















import BaseComponent from "@/core/components/BaseComponent";
import {Prop, Watch} from "vue-property-decorator";
import Component from "vue-class-component";
import {HasPhone} from "@/interfaces/HasPhone";

@Component({
    components: {

    }
})
export default class PhoneEdit extends BaseComponent {

    // Bindings to parent
    @Prop() model?: HasPhone;

    // Bindings to view
    public phone?: string = '';

    // Data

    public created() {

    }

    public mounted() {
        this.renderView();
    }

    private renderView() {
        if (this.model?.phone) {
            this.phone = this.model.phone;
        }
        this.isReady = true;
    }

    private save(event: any) {
        this.model!.phone = event.formatInternational;
    }

}
